import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { HashRouter, Routes, Route } from "react-router-dom";
import { ROUTE_PATHS, LanguageProvider } from "@/lib/index";
import { Layout } from "@/components/Layout";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Services from "@/pages/Services";
import Contact from "@/pages/Contact";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import TermsOfService from "@/pages/TermsOfService";
import ComplianceStatement from "@/pages/ComplianceStatement";
import AdvisoryBoard from "@/pages/AdvisoryBoard";
import CompanyNews from "@/pages/CompanyNews";
import CompanyNewsDetail from "@/pages/CompanyNewsDetail";

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <LanguageProvider>
      <TooltipProvider>
        <Toaster />
        <Sonner />
        <HashRouter>
          <Layout>
            <Routes>
              <Route path={ROUTE_PATHS.HOME} element={<Home />} />
              <Route path={ROUTE_PATHS.ABOUT} element={<About />} />
              <Route path={ROUTE_PATHS.SERVICES} element={<Services />} />
              <Route path={ROUTE_PATHS.CONTACT} element={<Contact />} />
              <Route path={ROUTE_PATHS.PRIVACY} element={<PrivacyPolicy />} />
              <Route path={ROUTE_PATHS.TERMS} element={<TermsOfService />} />
              <Route path={ROUTE_PATHS.COMPLIANCE} element={<ComplianceStatement />} />
              <Route path={ROUTE_PATHS.ADVISORY} element={<AdvisoryBoard />} />
              <Route path={ROUTE_PATHS.NEWS} element={<CompanyNews />} />
              <Route path={`${ROUTE_PATHS.NEWS}/:id`} element={<CompanyNewsDetail />} />
            </Routes>
          </Layout>
        </HashRouter>
      </TooltipProvider>
    </LanguageProvider>
  </QueryClientProvider>
);

export default App;